angular.module('signalview.userAnalytics', ['sfx.data']);
